import React from 'react';
import {Draggable} from 'react-beautiful-dnd';
import {format} from 'date-fns';

import {DragButton} from 'components';

import {Component} from './types';
import {selectImageFile, componentName} from './utils';
import {COMPONENT_TYPES} from './constants';

type BitComponentProps = {
  data: Component;
  index: number;
  onEdit: (id: string) => void;
  disabled?: boolean;
};

function BitComponent({
  data: {id, type, value, dateValue},
  index,
  onEdit,
  disabled,
}: BitComponentProps) {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          className={`flex justify-between items-center h-16 border-b border-skyblue bg-white ${
            snapshot.isDragging ? 'shadow-skyblue-200 rounded-large' : ''
          }`}
          onClick={() => onEdit(id)}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <img src={selectImageFile(type)} alt="text" />
          <div className="flex flex-col w-full max-w-2xs ml-2">
            <div className="text-sm text-dim-gray">{componentName(type)}</div>
            <div className="truncate w-11/12">
              {dateValue && type && type === COMPONENT_TYPES.MEETING
                ? format(dateValue, 'dd MMM yyyy hh:mm a')
                : type !== COMPONENT_TYPES.OPEN_QUESTION &&
                  type !== COMPONENT_TYPES.MULTIPLE_CHOICES
                ? value
                : ''}
            </div>
          </div>
          <span className={disabled ? 'invisible' : ''}>
            <DragButton {...provided.dragHandleProps} />
          </span>
        </div>
      )}
    </Draggable>
  );
}

export default BitComponent;
